import { VariantDetails } from 'modules/experiments/components/ui';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { ExperimentVariantRowDataProps } from 'modules/experiments/types';
import { StyledVariantTableCell } from './Styled';

export const VariantDetailsCell = ({ row }: ExperimentVariantRowDataProps) => {
  const { t } = useExperimentsTranslations();
  return (
    <StyledVariantTableCell data-test="experiment-variant-details-cell">
      <VariantDetails
        id={row.variantTemplateID}
        name={row.variantName}
        subTitle={t('variantTable.cell.id', { id: row.variantTemplateID })}
        templateThumbnailUrl={row.templateThumbnailUrl}
        messageMedium={row.messageMedium}
        control={row.control}
        winner={row.winner}
      />
    </StyledVariantTableCell>
  );
};
